import {Point} from './Point';

/**
 * A bounding box defines the boundaries of a rectangle. Semantically it directly exposes the left, top, right, and bottom
 * boundaries, and calculates the width and height, so it's slightly more performant for use cases where the borders
 * are more interesting than the properties of the rectangle.
 */
export class BoundingBox {
  constructor (l, t, r, b) {
    this.set(l, t, r, b);
  }

  set (l = 0, t = 0, r = 0, b = 0) {
    this.left = Number(l);
    this.right = Number(r);
    this.top = Number(t);
    this.bottom = Number(b);
  }

  zero () {
    this.set(0, 0, 0, 0);
  }

  isZero () {
    return (this.w <= 0 || this.h <= 0);
  }

  getCenter () {
    return new Point(this.cx, this.cy);
  }

  getArea () {
    return this.area;
  }

  hasOverlap (rect2) {
    return !(this.left > rect2.right || rect2.left > this.right || this.top > rect2.bottom || rect2.top > this.bottom);
  }

  intersect (rect2) { // modifies the rect to be that of the intersection with the passed rect
    if (rect2.left > this.left) this.left = rect2.left;
    if (rect2.top > this.top) this.top = rect2.top;
    if (rect2.right < this.right) this.right = rect2.right;
    if (rect2.bottom < this.bottom) this.bottom = rect2.bottom;
    if (this.left >= this.right || this.top >= this.bottom) { this.zero(); }
  }

  getIntersectRect (crect2) { // preserves this rect, returns the intersection between this and the passed rect
    var rtnRect2 = new BoundingBox(this.left, this.top, this.right, this.bottom);
    rtnRect2.intersect(crect2);
    return rtnRect2;
  }

  get w () {
    return this.right - this.left;
  }

  get h () {
    return this.bottom - this.top;
  }

  get cx () {
    return this.left + this.w / 2.0;
  }

  get cy () {
    return this.top + this.h / 2.0;
  }

  get area () {
    return this.w * this.h;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/objects/BoundingBox.js